import styled from "styled-components";
import { theme } from '../../theme'

export const StyledAchievementsGrid = styled.div`
display: grid;
grid-template-columns: repeat(auto-fit, minmax(34.6rem, 1fr));
grid-column-gap: 1.7rem;
grid-row-gap: 3.6rem;
`;

export const StyledNextButton = styled.div`
    position: absolute;
    top: 50%;
    right: 0;
    background-color: ${theme.colors.white};
    border-radius: 50%;
    z-index: 3;
    cursor: pointer;
    display: flex;
    align-items:center;
    justify-content: center;
    width: 3.4rem;
    height: 3.4rem;
    transform: translate(50%, -50%);
    color: #565B73;
    box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.1);

    svg {
        width: 15px;
        height: 15px;
    }
`